
import AdminHeader from "./header";
import Footer from "./footer";

const Layout = ({ children }) => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      backgroundColor: '#f8f9fa' 
    }}>
      <AdminHeader />
      
      <main style={{ 
        flex: 1, 
        padding: '20px',
        paddingTop: '80px', 
        minHeight: 'calc(100vh - 120px)' 
      }}>
        {children}
      </main>
      
      <Footer />
    </div>
  );
};

export default Layout;